import { useMasterApprenticesStore } from '@/features/teacher-student/store';
import { FC } from 'react';
import { TeacherStudentHeader } from '../../header/Header';
import { headerData } from './constants';
import { TableDistrict } from './table/TableDistrict';

export const TerritoryTeacherStudent: FC = () => {
  const { masterApprenticesDistrictHeader } = useMasterApprenticesStore();

  return (
    <div className="flex flex-col gap-4 p-8">
      <TeacherStudentHeader
        title={`${masterApprenticesDistrictHeader?.district_name} bo'yicha ustoz-shogirdlar`}
        headerData={headerData}
        isResponsible={false}
      />
      <TableDistrict />
    </div>
  );
};
